module.exports = "<div class=\"dashboard-container bg-light-soft\" style=\"height: 100vh\">\n  <div class=\"login-container\">\n  <i class=\"pe-7s-way text-success\" style=\"font-size: 12em;\"></i><span class=\"text-muted\" style=\"font-size: 12em;\">404</span>\n  <h2>Page Not Found</h2>\n  <p> Sorry, but the page you are looking for has not been found. Try checking the URL for error, then hit the refresh\n    button on your browser or try found something else in our app. </p>\n  <a class=\"btn btn-sm btn-success pull-right\" ui-sref=\"admin\">Return to Home Page</a>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./client/pages/404/notfound.html
// module id = 736
// module chunks = 0